import { RiCloseFill } from "react-icons/ri"
import { 
    AbsoluteContainer, AppLabel, AppText, Circle, CustomContainer, 
    Divider, 
    FlexRow, GridContainer, SidePopup, SidePopupContainer 
} from "src/style"
import { ReactComponent as IncomeTransaction } from 'src/assets/img/income-transaction.svg'
import helpers from "src/utils/helpers"

export const ErrorLogDetails: React.FC<any> = ({data, close}) => {
    return (
        <>
            <SidePopupContainer onClick={close} />
            <SidePopup padding="3" data-aos="slide-left" width="58.5">
                <FlexRow justifyContent="space-between" rightPadding="4" topMargin="2.5" bottomMargin="2">
                    <AppLabel textSize="2" color="#16192C" fontWeight="600">Error Log Details</AppLabel>
                    <AbsoluteContainer top="0" right="0" onClick={close}>
                        <RiCloseFill className='close-icon' />
                    </AbsoluteContainer>
                </FlexRow>
                <CustomContainer topMargin="6">
                    <GridContainer>
                        <Circle size="6.4" bgColor="#F7FAFC">
                            <IncomeTransaction/>
                        </Circle>
                    </GridContainer>
                    <CustomContainer 
                        minHeight="48.2" radius="1.2" bgColor="#F7FAFC" 
                        padding="2" topMargin="2.5"
                    >
                        <FlexRow justifyContent="space-between" alignItems="flex-start" bottomMargin="2.5" gap="2.5">
                            <AppLabel>Error ID</AppLabel>
                            <AppText fontWeight="600" color="#16192C" textWrap='anywhere'>{data?.id}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" alignItems="flex-start" bottomMargin="2.5" gap="2.5">
                            <AppLabel>Originating Service</AppLabel>
                            <AppText fontWeight="600" color="#16192C" textWrap='anywhere'>{data?.originatingService}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" alignItems="flex-start" bottomMargin="2.5" gap="2.5">
                            <AppLabel>Endpoint/Method</AppLabel>
                            <AppText fontWeight="600" color='#16192C' textWrap='anywhere'>{data?.endpointOrMethod}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" alignItems="flex-start" bottomMargin="2.5" gap="2.5">
                            <AppLabel>Date</AppLabel>
                            <AppText fontWeight="600" color="#16192C">{data?.timeStamp ? `${helpers.splitDateTime(data.timeStamp)?.date} ${helpers.splitDateTime(data.timeStamp)?.completeTime}` : '-'}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" alignItems="flex-start" bottomMargin="2.5" gap="2.5">
                            <AppLabel>Unique Identifier</AppLabel>
                            <AppText fontWeight="600" color='#16192C' textWrap='anywhere'>{data?.uniqueIdentifier}</AppText>
                        </FlexRow>
                        <FlexRow 
                            justifyContent="space-between" alignItems="flex-start" 
                            bottomMargin="2.5" gap="2.5"
                        >
                            <AppLabel>Error Message</AppLabel>
                            <AppText 
                                fontWeight="600" color="#16192C" textWrap='anywhere' align="right"
                            >
                                {data?.errorMessage}
                            </AppText>
                        </FlexRow>
                        <Divider margin="5" bgColor="rgba(160, 174, 192, 0.4)" />
                    </CustomContainer>
                </CustomContainer>
            </SidePopup>
        </>
    )
}